<script setup>
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconPlus from '@/components/icon/IconPlus.vue'
import IconArchiveBox from '@/components/icon/IconArchiveBox.vue'

const emit = defineEmits(['browse-files', 'add-source'])
</script>

<template>
	<div class="bg-surface-2 rounded-lg p-10 text-center flex flex-col items-center">
		<div class="w-12 h-12 rounded-full bg-surface-3 flex items-center justify-center mb-3">
			<icon-base :width="22" :height="22" :width-view-box="24" :height-view-box="24" fill="none"
				class="text-surface-7">
				<icon-archive-box />
			</icon-base>
		</div>
		<h4 class="text-base font-medium text-white m-0">No items scheduled yet</h4>
		<p class="text-tiny text-surface-7 mt-1 mb-4 max-w-sm">
			Add a source or upload content in the Files tab, then arrange it here to build your channel.
		</p>
		<div class="flex flex-col md:flex-row gap-3">
			<FormButton type="secondary" class="justify-center" @click="emit('browse-files')">
				Browse files
			</FormButton>
			<FormButton class="justify-center" @click="emit('add-source')">
				<icon-base class="mr-2">
					<icon-plus />
				</icon-base>
				Add source
			</FormButton>
		</div>
	</div>
</template>

<style scoped></style>
